var map = {
	"./Logotipo 1.png": "905d",
	"./Logotipo Chronos.svg": "c87e",
	"./Logotipo Grupo Merca.svg": "6cd6",
	"./Logotipo Yego.svg": "22f0",
	"./Portada.png": "0471"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";